export default __webpack_public_path__ + "static/media/filter.d1d3a96c.svg";